import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";

function Randing168({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/168/01.gif`}
      numberColor="#0156fd"
      qOptionColor="blue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/nextStepButton2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      companyName="본원"
      privacyCompanyName="열린치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/infocenter.jpg`}
    />
  );
}

export default Randing168;
